import { useMemo } from 'react'
import type { User } from 'firebase/auth'
import type { UserProfile } from '../types'

// Merges the current user's auth-state profile into a Firestore-profiles map.
// The Firestore copy (if present) wins, since it carries the user-editable
// photoURL — this matches the precedence used in EventPage and HomePage.
export function useMergedSelfProfile(
  user: User | null,
  profiles: Record<string, UserProfile>,
): Record<string, UserProfile> {
  return useMemo(() => {
    if (!user) return profiles
    return {
      [user.uid]: {
        uid: user.uid,
        displayName: user.displayName ?? '',
        photoURL: user.photoURL,
      },
      ...profiles,
    }
  }, [profiles, user])
}
